import { ready } from '@util/global';

import { initLayout } from '@util/layout';

ready(() => {
  initLayout();

  var form = document.getElementById('loginForm');

  form.addEventListener(
    'submit',
    function () {
      document.getElementById('loginSubmitButton').setAttribute('disabled', 'disabled');
    },
    false
  );
});
